export enum ImportFileErrorCode {
  FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED',
  INVALID_MIME_TYPE = 'INVALID_MIME_TYPE',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  PARSE_ERROR = 'PARSE_ERROR'
}
